import { rutinInfos } from '../../_Common/Const/RutinInfo';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const PURutiner = {
  rtnProgramAndring: {
    component: getStandardRutin(
      rutinInfos.rtnProgramAndring,
      'PUProgramAndring'
    ),
  },
  rtnFAQ: {
    component: getStandardRutin(rutinInfos.rtnFAQ, 'PUFAQ'),
  },
  rtnUppdatering: {
    component: getStandardRutin(rutinInfos.rtnUppdatering, 'PUUppdatering'),
  },
};

export default PURutiner;
